import React from 'react';
import './DictionaryLinks.css';

const DictionaryLinks = ({ links }) => (
  <p className="dictionary-links">
    {links.map((link) => (
      <a key={link.href} href={link.href}>
        {link.label}
      </a>
    ))}
  </p>
);

export default DictionaryLinks;
